import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Glyphicon, Button } from '@bingads-webui-react/primitive';
import { withOverflowProp } from '@bingads-webui-react/with-overflow-prop';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { GetNodeClassNames } from '@bingads-webui-campaign-react/main-menu';
import { TextSpanWithForwardedRef } from './text-span-with-forwarded-ref';

function getNodeText(scope, classes, node, forwardedRef) {
  function getNodeUrl() {
    const { location, processor, allowedKeys } = scope || {};
    const params = new QueryParam(location, null, null, processor, allowedKeys);
    params.append({ tagId: node.Id });
    return location && location.pathname ? `${location.pathname}?${params.stringify()}` : null;
  }

  // disable clicking on links, only allow to open in new tabs/windows
  function onClick(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
  }

  function getNodeTextImpl() {
    return (
      <TextSpanWithForwardedRef
        classes={classes}
        node={node}
        forwardedRef={forwardedRef}
      />
    );
  }

  const nodeUrl = getNodeUrl(node, location);
  const nodeText = getNodeTextImpl(classes, node, forwardedRef);

  return nodeUrl
    ? (<a className={classes.menuItemAnchor} href={nodeUrl} onClick={onClick} ref={forwardedRef}>{nodeText}</a>)
    : nodeText;
}

const UetTagsTreeNodeWithTooltip = ({
  classes, node, forwardedRef, scope,
}) => {
  const nodeClasses = [GetNodeClassNames(node, classes), 'main-menu-tree-node', 'uet-tree-node'];

  const iconContainerClassName = classNames([
    classes.iconContainer,
    classes.statusIconContainer]);

  const iconStatusClassName = classes.uetTagStatusIcon;

  const uetTagGlyphIcon = ((node.TrackingStatus === 'Unverified' || node.TrackingStatus === 'Inactive') && !node.IsReadOnly) ? 'ba-Warning' : '';
  const changeUrl = () => {
    scope.append({
      tagId: node.Id,
    });
    scope.save();
  };

  return (
    <span>
      <Button
        onClick={() => { changeUrl(); }}
        btnStyle="command"
        className={classNames(nodeClasses)}
        key={node.Id}
        id={`id-${node.Id}`}
        title={node.Name}
      >
        {getNodeText(scope, classes, node, forwardedRef)}
        <div className={iconContainerClassName}>
          <Glyphicon
            className={iconStatusClassName}
            glyph={uetTagGlyphIcon}
            iconStyle="error"
          />
        </div>
      </Button>
    </span>
  );
};

UetTagsTreeNodeWithTooltip.propTypes = {
  classes: PropTypes.shape({
    baseMenuItem: PropTypes.string.isRequired,
    textContainer: PropTypes.string.isRequired,
    iconContainer: PropTypes.string.isRequired,
    uetTagStatusIcon: PropTypes.string.isRequired,
    hiddenTooltip: PropTypes.string.isRequired,
  }).isRequired,
  node: PropTypes.shape({
    Id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    Name: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    TrackingStatus: PropTypes.string,
    IsReadOnly: PropTypes.bool,
    isSelected: PropTypes.bool,
  }).isRequired,
  forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  scope: PropTypes.instanceOf(QueryParam).isRequired,
};

UetTagsTreeNodeWithTooltip.defaultProps = {
  forwardedRef: null,
};

export default withScope(withOverflowProp(UetTagsTreeNodeWithTooltip));
